<template>
  <crm-menu :links="links">
    <router-view></router-view>
  </crm-menu>
</template>

<script>
import { mapGetters } from "vuex";
import CrmMenu from "./CRMMenu";
import { hasRole } from "../util";

export default {
  components: {
    CrmMenu
  },
  computed: {
    ...mapGetters(["isAdmin", "currentUser"]),
    canViewTeam() {
      if (!this.currentUser) return false;
      return (
        this.isAdmin ||
        hasRole(this.currentUser, "intake") ||
        hasRole(this.currentUser, "intake-management") ||
        hasRole(this.currentUser, "overlord")
      );
    },
    links() {
      let links = [
        { name: "My Day", path: `/crm` },
        { name: "Quick Log", path: `/crm/log` },
        { name: "Contacts", path: `/crm/contacts` },
        { name: "Activity", path: `/crm/activity` }
      ];
      if (this.canViewTeam) {
        links.push({ name: "Team", path: `/crm/team` });
      }
      return links;
    }
  }
};
</script>

<style scoped lang="scss"></style>
